import './InventoryStatus.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import { useIIFE } from '@boost-sd/core-js';
import useTranslation from '@hooks/useTranslation';
import { createClsNameMap } from '@utils';

const clsNameMap = createClsNameMap()('inventory-status');

export type InventoryStatusProps = {
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: string | number;
  fontSize?: string | number;
  inStockColor?: string;
  lowStockColor?: string;
  soldOutColor?: string;
  lowInventoryThreshold?: number;
  inventory: number | null;
  isSoldOut?: boolean;
};

const InventoryType = {
  SoldOut: 'inventorySoldOut',
  InStock: 'inventoryInStock',
  LowStock: 'inventoryLowStock',
};

const InventoryStatus = ({
  textTransform,
  fontFamily,
  fontStyle,
  fontWeight,
  fontSize,
  inStockColor,
  lowStockColor,
  soldOutColor,
  lowInventoryThreshold,
  inventory,
  isSoldOut,
}: InventoryStatusProps) => {
  const { t } = useTranslation();

  const translationKey = useIIFE(() => {
    if (isSoldOut) return InventoryType.SoldOut;

    if (lowInventoryThreshold === undefined || inventory === null) return '';

    if (inventory > lowInventoryThreshold) {
      return InventoryType.InStock;
    }

    return InventoryType.LowStock;
  });

  const mappingColor = {
    [InventoryType.SoldOut]: soldOutColor,
    [InventoryType.InStock]: inStockColor,
    [InventoryType.LowStock]: lowStockColor,
  };

  const color = translationKey ? mappingColor[translationKey] : '';

  return translationKey ? (
    <span
      className={clsNameMap.root()}
      style={{
        fontFamily,
        fontStyle,
        fontWeight,
        fontSize,
        color,
        textTransform,
      }}
    >
      {textTransform === 'none'
        ? t(`productItem.${translationKey}`, {
            count: inventory ?? 0,
          })
        : t(`productItem.${translationKey}`, {
            count: inventory ?? 0,
          }).toLowerCase()}
    </span>
  ) : null;
};

export default registryComponent('InventoryStatus', InventoryStatus);
